import { Checkbox, Radio } from "@mui/material";
import { colors } from "assets/colors/colors";
import { useController } from "react-hook-form";

export const BrandTableSelectableCell = ({
  column,
  rowData,
  formControl,
  formFieldName,
}) => {
  const isMultiple = column.isMultiple ?? false;
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name: formFieldName,
    control: formControl,
    defaultValue: isMultiple ? [] : null,
  });

  const isSelected = (isMultiple ? value : [value]).some((item) =>
    [item?.uuid, item].includes(rowData.uuid),
  );

  const handleChange = () => {
    if (isSelected) {
      onChange(
        isMultiple
          ? [...value].filter((item) => item.uuid !== rowData.uuid)
          : null,
      );
    } else {
      onChange(isMultiple ? [...value, rowData] : rowData);
    }
  };

  if (isMultiple) {
    return (
      <Checkbox
        checked={isSelected}
        onChange={handleChange}
        sx={
          error
            ? {
                color: colors.redError,
                "&.Mui-checked": { color: colors.redError },
              }
            : undefined
        }
      />
    );
  }

  return (
    <Radio
      checked={isSelected}
      onChange={handleChange}
      sx={
        error
          ? {
              color: colors.redError,
              "&.Mui-checked": { color: colors.redError },
            }
          : undefined
      }
    />
  );
};
